// SPDX-FileCopyrightText: 2025-2026 TU Wien.
// SPDX-License-Identifier: MIT

import React from "react";
import {
  UppyUploader,
  FileUploader,
  getInputFromDOM,
} from "@js/invenio_rdm_records";

// override the upstream uppy uploader to now allow selection of folders
export const TUppyUploader = (props) => {
  if (getInputFromDOM("deposits-use-uppy-ui")) {
    return <UppyUploader fileManagerSelectionType="files" {...props} />;
  } else {
    return <FileUploader {...props} />;
  }
};
